import { put, all, takeEvery, takeLatest, call } from "redux-saga/effects";
import { systemActions, systemActionsConstants } from "../actions";
import { _sharedWorkerUploadAvatar, _sharedWorkerDeleteAvatar } from "@/shared/store/system/saga";
import { TOAST_TYPE } from "@/shared/constants";
import { copyText } from "@/shared/utils/copy";

function* copy(action) {
  const { text, options } = action.data;
  const result = yield call(copyText, text);

  if (options?.noToast) {
    return;
  }
  if (result) {
    yield put(
      systemActions.toast(options?.successMessage || "@textCopied", TOAST_TYPE.success)
    );
  } else {
    yield put(
      systemActions.toast(options?.errorMessage || "@textNotCopied", TOAST_TYPE.error)
    );
  }
}

export default function* systemSaga() {
  yield all([
    takeEvery(systemActionsConstants.ACTION_COPY, copy),
    takeLatest(systemActionsConstants.UPLOAD_USER_AVATAR, _sharedWorkerUploadAvatar),
    takeLatest(systemActionsConstants.DELETE_USER_AVATAR, _sharedWorkerDeleteAvatar),
  ]);
}
